
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import { useState, } from 'react';
import {
    TextField,
    Grid2,
} from "@mui/material";
import { GlobalStyles } from '@mui/material';
import './Login.css';
import { Link, NavLink, useNavigate } from 'react-router-dom';
import { forgotPassword } from '../../../Services/auth';
import { updateOtpTime } from '../../../Actions/AuthAction';
import { ToastError, ToastSuccess } from '../../../CustomToaster/CustomToaster';
import { useDispatch } from 'react-redux';
import { InputError } from '../../Errors/ErrorText';
import lightLogo from '../../../Images/fouchain-logo-light.svg';




const ForgotPassword = () => {
    //custom code
    const navigate = useNavigate();

    const [email, setEmail] = useState("");
    const [errors, setErrors] = useState({
        email: "",
    });

    const [load, setLoad] = useState(false);
    const dispatch = useDispatch();


    const handleChange = (e) => {
        const value = e.target.value;

        setEmail(value);
    };

    const validateFocus = (e = null) => {
        let isValid = true;
        const formErrors = {};

        if (e) {
            const { name, value } = e.target;
            if (name === "email" && value.trim() && !/\S+@\S+\.\S+/.test(value)) {
                formErrors.email = "Email is invalid";
                isValid = false;
            }
            setErrors((prevErrors) => ({
                ...prevErrors,
                [name]: formErrors[name] || "",
            }));
        } else {
            if (!email) {
                formErrors.email = "Email is required";
                isValid = false;
            } else if (!/\S+@\S+\.\S+/.test(email)) {
                formErrors.email = "Email is invalid";
                isValid = false;
            }
            setErrors(formErrors);
        }

        return isValid;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (validateFocus()) {
            setLoad(true);

            const data = {
                email: email,
                // type:'email',
            };
            setLoad(true);
            const response = await forgotPassword(data);
            if (response?.data?.success === true) {
                ToastSuccess({ message: response?.data?.message, icon: false });
                dispatch(updateOtpTime(response?.data?.result?.time));
                navigate("/verify", {
                    state: {
                        data: response?.data?.result,
                        // type: "forgotpassword"
                        type: "Forget-Pass"
                    },
                });

                setLoad(false);
            } else {
                if (response?.data?.result?.blocked === true) {
                    dispatch(updateOtpTime(response?.data?.result?.time));

                    navigate("/verify", {
                        state: { data: response?.data?.result, type: "Forget-Pass" },
                    });
                } else {
                    ToastError({ message: response?.data?.message, icon: false });
                }
                setLoad(false);
            }
        }
    };



    return (
        <div className='auth-page login-page '>
            <GlobalStyles
                styles={{
                    ':root': {
                        '--Form-maxWidth': '800px',
                        '--Transition-duration': '0.4s',
                    },
                }}
            />
            <Box
                component="main"
                className='login-card'
            >
                <Link to={'/'}>
                    <div className="logo">
                        <img width={120} src={lightLogo} alt="logo" />
                    </div>
                </Link>

                <Stack sx={{ gap: 2, mb: 2 }} mt={2}>
                    <Stack sx={{ gap: 1 }}>
                        <Typography component="h1" className="gold-color" sx={{ fontSize: '35px', textAlign: 'center' }}>
                            Forget Password
                        </Typography>
                        <Typography level="body-sm" sx={{ fontSize: '16px', textAlign: 'center' }}>
                            Enter your email address and we’ll send you an email with instructions to reset your password
                        </Typography>
                    </Stack>
                </Stack>

                <form onSubmit={handleSubmit}>
                    <Grid2 container spacing={2}>
                        <Grid2 item size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
                            <FormControl fullWidth required>
                                <div className='input-common'>
                                    <FormLabel>Email</FormLabel>
                                    <TextField
                                        name="email"
                                        type="text"
                                        fullWidth
                                        value={email}
                                        onChange={(e) => handleChange(e)}
                                        onInput={validateFocus}
                                        error={!!errors.email}
                                    />


                                </div>
                                <InputError error={errors.email} />
                            </FormControl>
                        </Grid2>
                        <Grid2 item size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
                            <Stack spacing={2} mt={2}>
                                <div className='but-one text-center'>
                                    {
                                        load === true ?
                                            <Button type="submit" variant="contained" fullWidth
                                                disabled
                                            >
                                                Progressing
                                            </Button> :

                                            <Button type="submit" variant="contained" fullWidth
                                                onClick={(e) => {

                                                    handleSubmit(e);
                                                }}
                                            >
                                                Continue
                                            </Button>
                                    }
                                </div>
                            </Stack>
                        </Grid2>
                    </Grid2>
                </form>
                <div className="register-acctn mt-30 display-3">
                    <p className='wcl-p fllname-ft'>Go to <span style={{ paddingLeft: '5px' }}></span>  <NavLink className='reg-free gold-color' to='/login' style={{ color: '#3665FF !important' }}>  Sign In</NavLink></p>
                </div>
            </Box>

        </div>
    )
}

export default ForgotPassword
